<script>
export default {
  name: 'CandidateFilterMenu',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      radioGroup: 'mine',
      typeFilters: ['All', 'Candidate', 'Contact'],
    }
  },
  methods: {
    typeUpdated(val) {
      this.$emit('type-updated', val)
    },
    loadMyMessages() {
      this.$emit('select-my-messages')
    },
    loadTeamsMessages() {
      this.$emit('select-team-messages')
    },
  },
}
</script>

<template>
  <v-card>
    <v-card-subtitle>
      Filters
    </v-card-subtitle>
    <v-card-text>
      <div class="mb-2">
        <v-select
          ref="candidate-filter-menu-ref"
          :items="typeFilters"
          :value="type"
          label="Type"
          dense
          @input="typeUpdated"
        ></v-select>
      </div>
      <div class="mb-2">
        <v-radio-group v-model="radioGroup">
          <template v-slot:label>
            <div>Messages</div>
          </template>
          <v-radio label="Mine" value="mine" @click="loadMyMessages"></v-radio>
          <v-radio
            label="My Team"
            value="team"
            @click="loadTeamsMessages"
          ></v-radio>
        </v-radio-group>
      </div>
    </v-card-text>
  </v-card>
</template>
